import { simple_pages_helper } from "@/helpers/simple_pages_helper";

/**
 *
 * @param page
 * @returns {{component: string, props: {items: *[]}}|null}
 */
export const promoSection = ({ page }) => {
  if (!page || !("promo_section" in page)) {
    return null;
  }

  let pageItems = [];

  if ("promo_section" in page && Array.isArray(page.promo_section)) {
    pageItems = [
      ...page.promo_section
        .filter((i) => !!i.title)
        .map((i) => ({
          title: i.title ?? null,
          img: i.image ?? null,
          href: i.link ?? "#",
        })),
    ];
  }

  if ("show_sibling_promo_items" in page && page.show_sibling_promo_items === true) {
    pageItems = [
      ...pageItems,
      ...simple_pages_helper.fetch({ parent: page.parent.id }).map((i) => ({
        title: i.title ?? null,
        img: i.card_image ?? null,
        href: page.href.replaceAll(page.url_slug, i.url_slug),
      })),
    ];
  }

  if ("show_child_promo_items" in page && page.show_child_promo_items === true) {
    pageItems = [
      ...pageItems,
      ...simple_pages_helper
        .fetch({ parent: page.id })
        .map((i) => ({ title: i.title ?? null, img: i.card_image ?? null, href: `${page.href}/${i.url_slug}` })),
    ];
  }

  return {
    component: "PromoSection",
    props: {
      items: pageItems,
    },
  };
};
